import { render, staticRenderFns } from "./AdminServiceAreaCategoryCreate.vue?vue&type=template&id=3bbdc032"
import script from "./AdminServiceAreaCategoryCreate.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports